import Vue from 'vue'
import Vuex from 'vuex'
import AxiosProvider from './axiosProvider'
import { setUser as sentrySetUser } from '@g/utils/sentryInstall'
import { whsName, whsNameSimp } from '../filters'
import {
  getParameterByName,
  isTwCellphone,
  isTwLandline,
  getViewWidth,
} from '../utils'
import {
  isGuiNumberValid, // 統一編號
  isNationalIdentificationNumberValid, // 身分證字號
  isResidentCertificateNumberValid, // 居留證編號
} from '../utils/taiwanIdValidator'
import { isInApp, actSetUdSpUtil, actBindAliYunPush } from '@g/utils/appSDK'
import modules from './modules'
import eventBus, { eventType } from '@g/utils/eventBus'
import { normalizeInstallResponse } from '@g/utils/crxInstallCompat'

Vue.use(Vuex)

function getOs () {
  const ua = navigator.userAgent
  const isWindowsPhone = /(?:Windows Phone)/.test(ua)
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  const isAndroid = /(?:Android)/.test(ua)
  const isFireFox = /(?:Firefox)/.test(ua)
  // const isChrome = /(?:Chrome|CriOS)/.test(ua)
  const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet
  const isPc = !isPhone && !isAndroid && !isSymbian
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc
  }
}
// const userAgent = window.navigator.userAgent

const store = new Vuex.Store({
  state: {
    axios: AxiosProvider,
    barHeight: 0,

    os: getOs(),
    isPord: process.env.NODE_ENV === 'production',
    isTest: process.env.NODE_ENV !== 'production',
    project: process.env.project,
    inIframe: window.parent !== window.self,
    isDebug: false,

    isChrome: !!window.chrome,
    // extId,
    // extId: process.env.NODE_ENV === 'production' ? 'lacejchmbljdoaimkbmcflcechgndbim' : 'ahocnfagfcikfddlhcfoocphlelgbljb', // 线上
    // extId: 'ahocnfagfcikfddlhcfoocphlelgbljb', // 本地
    extId: 'lacejchmbljdoaimkbmcflcechgndbim', // 線上

    jySlug: '',
    jySlugName: '',
    smCellphone: '',

    // 汇率
    exchangeRate: 4.5,

    // 用戶信息、地址
    userData: localStorage.userData ? JSON.parse(localStorage.userData) : { settings: {} },
    userAddrs: [],
    userSignUpForm: localStorage.signUpFormGuide
      ? JSON.parse(localStorage.signUpFormGuide)
      : {
          fbAccessToken: '',
          appleIdentityToken: '',
          realname: '',
          nickname: '',
        },

    // 運費、倉庫
    jyShippingRatesSource: [],
    jyShippingRates: [],
    srunWarehouses: [],
    jyWarehouses: [],
    jyWarehousesSource: [],
    edition: localStorage.__edition__ || 'g', // g 通用版，s 企业版

    transport: {
      air: 'air',
      sea: 'sea',
      se: 'se'
    },

    // 提示
    vSnackbar: {
      text: '',
      show: false
    },

    keepAliveComponents: [], // 缓存数组

    prevPageData: null, // 上一个页面传过来的数据

    // 表單驗證規則
    validationRules: {
      required: (val) => (val && String(val).trim().length > 0) || '必填',
      email: (val) => /^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(val.trim()) || '請輸入正確的的E-MAIL地址',
      cellphone: (val) => {
        if (val) return /^09\d{8}$/.test(val.trim()) || '請輸入正確的手機號碼'
        return true
      },
      cnCellphone: (val) => {
        if (val) return /^\d{10,12}$/.test(val.trim()) || '請輸入正確的手機號碼'
        // if (val) return /^1\d{10}$/.test(val.trim()) || '請輸入正確的手機號碼'
        return true
      },
      cnAddr: (val) => {
        if (val) return /(自治区|省|市)/.test(val.trim()) || '請輸入正確的地址'
        return true
      },
      trackingNo: (val) => {
        if (val) return /^[a-zA-Z0-9-]{5,30}$/.test(val.trim()) || '請輸入正確的運單號碼'
        return true
      },
      landline: (val) => {
        // 台北 02 台中 04 +8位 其他地區 0x+7位，x=3至8
        if (val) return /^((0(2|4)\d{8})|(0[3-8]\d{7}))$/.test(val.trim().replace('-', '')) || '請輸入正確的座機號碼'
        return true
      },
      cellphoneOrLandline: (val) => {
        console.log('isTwCellphone(val)', isTwCellphone(val))
        console.log('isTwLandline(val)', isTwLandline(val))
        if (val && !isTwCellphone(val) && !isTwLandline(val)) {
          return '請輸入正確的手機號碼'
        }
        return true
      },
      tradevanName: (val) => {
        if (val) return /^[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\u{2F800}-\u{2FA1F}\u{20000}-\u{2A6DF}\uFF00-\uFFEF\u00B7\u2022a-zA-Z\s]*$/u.test(val.trim()) || '只能輸入中文漢字或英文'
        return true
      },
      hanzi: (val) => {
        // 双字节字符
        // if (val) return /^[^\x00-\xff]*$/.test(val.trim()) || '只能輸入中文漢字'
        if (val) return /^[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\u{2F800}-\u{2FA1F}\u{20000}-\u{2A6DF}\uFF00-\uFFEF\u00B7\u2022]*$/u.test(val.trim()) || '只能輸入中文漢字'
        // 慈 這字比較特殊，試了幾種方式匹配不到
        // if (val) return /^[\u3400-\u9fa5慈𢒑𣐀]*$/.test(val.trim()) || '只能輸入中文漢字'
        return true
      },
      nickname: (val) => {
        if (val) return /^[\u3400-\u9fa5]{2,5}$/.test(val.trim()) || '暱稱長度為2-5位漢字'
        return true
      },
      password: (val) => {
        if (val) return /^[\w!@#$%^&*()_+-`~]{6,32}$/.test(val.trim()) || '密碼長度為6~32字元'
        return true
      },
      captcha: (val) => {
        if (val) return /^\w{6}$/.test(val.trim()) || '驗證碼為6位數字'
        return true
      },
      idNum: (val) => {
        if (val) {
          val = val.trim()
          if (/^(\d{8})$/.test(val)) {
            // 公司营业执照号
            return isGuiNumberValid(val) ? true : '請輸入正確的統一編號'
          }
          if (/^([a-zA-Z]{2}\d{8})$/.test(val)) {
            // 舊居留证
            // return '暫不支持居留證'
            return isResidentCertificateNumberValid(val) ? true : '請輸入正確的居留證編號'
          }
          if (/^[a-zA-Z]{1}[8,9]{1}[0-9]{8}$/.test(val)) {
            // 新居留证
            return true
            // return isResidentCertificateNumberValid(val) ? true : '請輸入正確的居留證編號'
          }
          if (/^[a-zA-Z]{1}[1-2]{1}[0-9]{8}$/.test(val)) {
            // 身份证
            return isNationalIdentificationNumberValid(val) ? true : '請輸入正確的身分證字號'
          }
          return '請輸入正確的身分證字號或統一編號'
        }
        return true
      },
      guiNum: (val) => {
        if (val) {
          val = val.trim()
          if (/^(\d{8})$/.test(val)) {
            // 公司营业执照号
            return isGuiNumberValid(val) ? true : '請輸入正確的統一編號'
          }
          return '請輸入正確的統一編號'
        }
        return true
      },
      // 品名
      parcelDesc: (val) => {
        if (val) {
          // 漢字和字母T 逗號
          return /^[A-Za-z0-9，,\u3400-\u9fa5]*$/i.test(val.trim()) || '只能輸入中文漢字、英文字母和數字'
        }
        return true
      },
      maxLen: (len) => (val) => (val && val.trim().length <= len) || '最多輸入' + len + '個字元',
      maxViewWidth: (len) => (val) => (!val || getViewWidth(val.trim()) <= len) || '最多輸入' + len + '個字元',
      minLen: (len) => (val) => (val && val.trim().length >= len) || '最少輸入' + len + '個字元',
    },

    // 颜色
    colors: [
      'red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue',
      'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime',
      'yellow', 'amber', 'orange', 'deep-orange', 'brown', 'blue-grey'
    ],

    // 是否顯示新增地址表單
    showAddressDialogForm: false,
    modelAddressDialogForm: {
      // city: '',
      // district: '',
      // desc: '',
      // postcode: '',
    },

    searchTrackingNoing: false,

    installedCrx: false,
    crxRuntimeInfo: normalizeInstallResponse(null),
    timeDeviation: 0, // 本地时间与服务器时间的偏差

    // 系统维护信息：任一接口返回 maintenance===true 时由 axios 拦截器写入，非空即显示全屏维护页
    maintenance: null,
  },
  getters: {
    gtagEvent: (state) => (action, category, label = '', value = '') => {
      // if (window.gtag) {
      //   gtag('event', action, {
      //     'event_category': category,
      //     'event_label': label,
      //     'value': value
      //   })
      // }
    },

    gaEvent: () => (eventCategory, eventAction, eventLabel, eventValue) => {
      // https://developers.google.com/analytics/devguides/collection/analyticsjs/events?hl=zh-cn
      window.ga && window.ga('send', 'event', eventCategory, eventAction, eventLabel, eventValue)
    },
    hasCompanyAddr: (state) => {
      // return state.userAddrs.some((addr) => String(addr.isCompany) === '1')
      return state.userData.actor & 2
    },
    isLong91: (state) => {
      // 91会员是否过期
      return state.userData.userbelogLong91?.beExpiredTime > Math.floor(Date.now() / 1000)
    },
  },
  mutations: {
    setIsTest (state, v) {
      state.isTest = v
    },
    init (state, data) {
      if (!data) {
        state.userData = {
          settings: {}
        }
        state.jyWarehouses = []
        return
      }
      let syncWhsAddrids = data.user.syncWhsAddrids
      if (typeof syncWhsAddrids === 'string') {
        syncWhsAddrids = JSON.parse(syncWhsAddrids)
      }
      if (syncWhsAddrids) {
        if (!syncWhsAddrids.taobao) {
          syncWhsAddrids.taobao = []
        }
        if (!syncWhsAddrids['1688']) {
          syncWhsAddrids['1688'] = []
        }
        syncWhsAddrids.taobao = Object.values(syncWhsAddrids.taobao)
        syncWhsAddrids['1688'] = Object.values(syncWhsAddrids['1688'])
      }
      state.userData = {
        ...data.user,
        quiz: data.quiz,
        hasParcel: data.hasParcel,
        hasJyorder: data.hasJyorder,
        commentUnread: data.commentUnread,
        chatUnread: data.chatUnread,
        jyorderPayDelay: data.jyorderPayDelay,
        jyorderTaxesCcf: data.jyorderTaxesCcf,
        vaordersPayDelay: data.vaordersPayDelay,
        options: data.options,
        pushns: data.pushns,
        postPopups: data.postPopups,
        syncWhsAddrids,
      }
      localStorage.userData = JSON.stringify(state.userData)
      state.userAddrs = data.userAddrs
      const jyShippingRates = data.jyShippingRates.filter(item => {
        return item.addrid === data.user.defaultWhsAddrid
      })
      data.jyShippingRates.forEach(item => {
        if (jyShippingRates.findIndex(item2 => item2.type === item.type) === -1) {
          jyShippingRates.push(item)
        }
      })

      state.jyShippingRates = jyShippingRates
      const jyWarehouses = data.jyWarehouses

      state.jyWarehouses = jyWarehouses
        .filter(item => item.addrid !== '1050' && item.addrid !== '2591')
        .map(item => {
          if (item.addrid === '1579') {
            return {
              ...item,
              country: 'CN',
              province: '浙江省',
              city: '金华市',
              district: '义乌市',
              street: '稠江街道',
              desc: '红狮智慧物流园二区D6-4棟沛宝仓',
              postcode: '310025',
              mobile: '18058928173',
              mobileHr: '18058928173',
              label: '义乌海快倉',
              isInvalid: '0'
            }
          }
          return item
        })
        .map(item => {
          let desc = item.desc
          let mobileHr = item.mobileHr
          if (state.project.startsWith('mgb') && item.addrid === '1596') {
            desc = '宝湾国际智慧产业园4栋一楼'
            mobileHr = '18059668952'
          }
          return {
            ...item,
            formatAddr: {
            // name: `${state.userData.nickname || ''}(kkr${Number(state.userData.cellphone).toString(36)})`,
              name: `${state.userData.nicknameCn || ''}(${state.userData.cellphone36})`,
              viewName: `${state.userData.nickname || ''}(${state.userData.cellphone})`, // 只用来显示，不设置到淘宝
              phone: mobileHr,
              postcode: item.postcode,
              addr: `${item.province}${item.city}${item.district} ${item.street}${desc}-${state.userData.uid}號`,
              seaAddr: `${item.province}${item.city}${item.district} 双岗下环新涌路2栋海运家具-${state.userData.uid}號`,
              uidNum: `-${state.userData.uid}號`
            }
          }
        })
      state.jyWarehousesSource = data.jyWarehouses
      state.srunWarehouses = data.srunWarehouses
      const jyShippingRatesSource = [...data.jyShippingRates]
      jyShippingRatesSource.sort((a, b) => {
        return a.addrid - b.addrid
      })
      jyShippingRatesSource.filter(sr => sr.addrid === '3591').forEach(sr => {
        jyShippingRatesSource.push({
          ...sr,
          srid: '1579' + sr.srid,
          addrid: '1579',
        })
      })
      state.jyShippingRatesSource = jyShippingRatesSource.map(item => {
        let label = whsName(item.addrid)
        if (item.addrid === '1592') {
          if (item.srLabel === 'ECONOMY-ALL') {
            label = whsNameSimp(item.addrid) + '經濟'
          } else {
            label = whsNameSimp(item.addrid) + '特快'
          }
        }
        return {
          ...item,
          label,
        }
      })

      // localStorage.store_jyWarehouses = JSON.stringify(state.jyWarehouses)
      // localStorage.store_jyShippingRatesSource = JSON.stringify(state.jyShippingRatesSource)
    },
    setPrevData (state, data) {
      state.userInfo = data.user
      state.userAddrs = data.userAddrs
      state.jyShippingRates = data.jyShippingRates
      state.jyWarehouses = data.jyWarehouses
      state.jyShippingRatesSource = data.jyShippingRatesSource
      state.prevPageData = JSON.parse(JSON.stringify(data))
    },
    setSearchTrackingNoing (state, data) {
      state.searchTrackingNoing = data
    },
    setUserAddrs (state, data) {
      state.userAddrs = data
    },
    setExtId (state, v) {
      state.extId = v
    },
    setVSnackbar (state, [text, show = true, timeout = 5000]) {
      state.vSnackbar.text = text
      state.vSnackbar.show = show
      state.vSnackbar.timeout = timeout
    },
    setAddressDialogForm (state, [show, model]) {
      state.showAddressDialogForm = show
      state.modelAddressDialogForm = {
        isCompany: 0,
        ...JSON.parse(JSON.stringify({
          mobile: '',
          city: '',
          district: '',
          desc: '',
          postcode: '',
          chaoshang: {},
          ...model
        }))
      }
    },
    setJySlug (state, v) {
      state.jySlug = v
    },
    setBarHeight (state, v) {
      state.barHeight = v
    },
    setJySlugName (state, name) {
      state.jySlugName = name
    },
    setSmCellphone (state, v) {
      state.smCellphone = v
    },
    keepAlive (state, component) {
      if (!state.keepAliveComponents.includes(component)) {
        state.keepAliveComponents.push(component)
      }
    },
    noKeepAlive (state, component) {
      const index = state.keepAliveComponents.indexOf(component)
      if (index !== -1) {
        state.keepAliveComponents.splice(index, 1)
      }
    },
    clearKeepAlive (state) {
      state.keepAliveComponents = []
    },
    setInstalledCrx (state, v) {
      state.installedCrx = v
    },
    setCrxRuntimeInfo (state, value) {
      state.crxRuntimeInfo = value
    },
    setEdition (state, v) {
      state.edition = v
      localStorage.__edition__ = v
    },
    setIsDebug (state, v) {
      state.isDebug = v
    },
    setMaintenance (state, info) {
      state.maintenance = info
    },
  },
  actions: {
    saveSignUpForm ({ state, commit, rootState }) {
      localStorage.signUpFormGuide = JSON.stringify(state.userSignUpForm)
    },
    async initSlug ({ state, commit, dispatch }) {
      let jySlug = getParameterByName('jySlug')
      const smSlug = getParameterByName('smSlug')
      if (!jySlug) {
        if (location.hostname.indexOf('jyb.com.tw') !== -1) {
          const hostname = location.hostname.split('.')[0]
          if (hostname !== 'www' && hostname !== 'm') {
            jySlug = hostname
          }
        }
      }
      if (smSlug) {
        // await dispatch('user/viewSlug', { smSlug }).then((res) => {
        //   jySlug = res.data.jySlug
        //   commit('setJySlugName', res.data.jyRealname)
        //   commit('setSmCellphone', res.data.smCellphone)
        // })
      }
      commit('setJySlug', jySlug)
    },
    // 初始化数据，获取已登录用户信息
    init ({ state, commit, dispatch }) {
      return dispatch('jyb/userPrepare/init').then(async (res) => {
        if (!res.data.error) {
          res.data.model.jyorderTaxesCcf = await dispatch('jyo/jyorder/formatOrder', res.data.model.jyorderTaxesCcf)
          res.data.model.userAddrs = await dispatch('address/formatAddr', res.data.model.userAddrs)

          if (res.data.model.user?.nickname) {
            if (localStorage.getItem('nickname' + res.data.model.user.nickname)) {
              res.data.model.user.nicknameCn = localStorage.getItem('nickname' + res.data.model.user.nickname)
            } else {
              const nickNameCnRes = await dispatch('user/viewNicknameCn')
              res.data.model.user.nicknameCn = nickNameCnRes.data.model.nicknameCn
              localStorage.setItem('nickname' + res.data.model.user.nickname, res.data.model.user.nicknameCn)
            }
          }

          commit('init', res.data.model)
          commit('realppl/realpplAuth/SET_AUTH_INFO', res.data.model.realpplAuth)
          await dispatch('realppl/realpplAuth/viewExamPass')
          sentrySetUser({
            id: res.data.model.user?.uid,
            username: res.data.model.user?.nickname,
          })
        }
        return res
      })
    },
    logout ({ commit }) {
      const deviceUdid = localStorage.deviceUdid
      const loginCount = localStorage.loginCount
      const aosAnaVisitor = localStorage.aos_ana_visitor
      // 行销来源（?referrer= 持久化）不是登录态，登出后保留给下一次注册归因
      const signupReferrer = localStorage.signupReferrer
      localStorage.clear()
      localStorage.deviceUdid = deviceUdid
      localStorage.loginCount = loginCount
      localStorage.aos_ana_visitor = aosAnaVisitor
      if (signupReferrer) localStorage.signupReferrer = signupReferrer

      sessionStorage.removeItem('mgb:dgorder:prepareModel')
      sessionStorage.removeItem('mgb:dgorder:categoryPathsModel')

      // localStorage.removeItem('useWebClient')
      // localStorage.removeItem('accessToken')
      if (isInApp()) {
        actSetUdSpUtil('accessToken', '')
        actSetUdSpUtil('uid', '')
        actBindAliYunPush('')
      }

      window.vueApp.$store.state.userSignUpForm.fbAccessToken = ''
      window.vueApp.$store.state.userSignUpForm.appleIdentityToken = ''
      window.vueApp.$store.state.userSignUpForm.nickname = ''
      window.vueApp.$store.dispatch('saveSignUpForm')
      commit('init', null)
      sentrySetUser(null)
      location.href = '#/noLoginHome'
    },
    checkInstallCrx (context) {
      const { state, commit } = context
      return new Promise(resolve => {
        const el = document.querySelector('#kkren-conrome-crx-id')
        const markerText = el ? el.innerHTML : ''
        let extId = state.extId
        if (el) {
          const s = markerText.split(':')
          if (s[1] && s[1] !== state.extId) {
            commit('setExtId', s[1])
            extId = s[1]
          }
        }
        let installedResponseReceived = false
        window.chrome.runtime && window.chrome.runtime.sendMessage(extId, {
          CMD: 'CHECKINSTALL'
        }, reply => {
          const runtimeInfo = normalizeInstallResponse(reply, markerText)
          if (runtimeInfo.installed) {
            installedResponseReceived = true
            commit('setCrxRuntimeInfo', runtimeInfo)
            commit('setInstalledCrx', true)
            resolve(true)
          }
        })
        setTimeout(() => {
          if (!installedResponseReceived) {
            commit('setCrxRuntimeInfo', normalizeInstallResponse(null, markerText))
          }
          resolve(false)
        }, 1000)
      })
    },
    viewPost ({ state }, poidSlug) {
      eventBus.$emit(eventType.OpenPostDetaildDialog, poidSlug)
    },
  },
  modules
})

store.dispatch('theme/initTheme')
localStorage.removeItem('store_jyShippingRatesSource')
localStorage.removeItem('store_jyWarehouses')

export default store
